import Cookies from 'js-cookie';
import eePromoClickHandler from './eePromoClickHandler';

const handlePromoDetailsTracking = (cookieName: string) => {
  const promoDetails = Cookies.get(cookieName);

  let parsedPromoDetails;

  if (promoDetails) {
    try {
      parsedPromoDetails = JSON.parse(promoDetails);
    } catch (e) {
      console.error(`Error parsing ${cookieName} cookie`, e);
    }
  }

  if (parsedPromoDetails) {
    eePromoClickHandler(parsedPromoDetails);
    Cookies.remove(cookieName);
  }
};

export default handlePromoDetailsTracking;
